import { render, staticRenderFns } from "./bank-requests.vue?vue&type=template&id=6b64ed10&"
import script from "./bank-requests.vue?vue&type=script&lang=js&"
export * from "./bank-requests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports